class Announcement extends HTMLElement {
  constructor() {
    super();
    this.announcementItems = this.querySelectorAll('.announcement__item');
    this.currentIndex = 0;
    this.rotationInterval = null;
    this.isInitialized = false;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  init() {
    if (this.isInitialized) return;
    
    this.isInitialized = true;
    
    if (this.announcementItems.length > 1 && this.isMobile()) {
      this.setupMobileRotation();
    }
    
    this.resizeHandler = this.handleResize.bind(this);
    window.addEventListener('resize', this.resizeHandler);
  }

  isMobile() {
    return window.innerWidth <= 1000;
  }

  setupMobileRotation() {
    this.announcementItems.forEach((item, index) => {
      if (index === 0) {
        item.classList.add('announcement__item--active');
      } else {
        item.classList.add('announcement__item--hidden');
      }
    });
    
    this.startRotation();
  }

  startRotation() {
    if (this.rotationInterval) {
      clearInterval(this.rotationInterval);
    }
    
    this.rotationInterval = setInterval(() => {
      this.rotateItems();
    }, 3000);
  }

  rotateItems() {
    if (!this.isMobile()) return;
    
    this.announcementItems[this.currentIndex].classList.remove('announcement__item--active');
    this.announcementItems[this.currentIndex].classList.add('announcement__item--hidden');
    
    this.currentIndex = (this.currentIndex + 1) % this.announcementItems.length;
    
    this.announcementItems[this.currentIndex].classList.remove('announcement__item--hidden');
    this.announcementItems[this.currentIndex].classList.add('announcement__item--active');
  }

  handleResize() {
    if (!this.isMobile()) {
      this.stopRotation();
      this.showAllItems();
    } else if (this.announcementItems.length > 1) {
      this.setupMobileRotation();
    }
  }

  stopRotation() {
    if (this.rotationInterval) {
      clearInterval(this.rotationInterval);
      this.rotationInterval = null;
    }
  }

  showAllItems() {
    this.announcementItems.forEach(item => {
      item.classList.remove('announcement__item--hidden', 'announcement__item--active');
    });
  }

  cleanup() {
    this.stopRotation();
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }
}

customElements.define('announcement-bar', Announcement);